import {useSelector} from "react-redux";

/** The logged-in user's role, sourced from the DB (via the AM API), not the Entra ID token.
 * @returns {string} role text from roleConstants, e.g. "App.Admin"
 */
export default function useUserRole() {
    return useSelector(state => state.user.user.role)
}
